import { requestBuilder } from '../../http/RequestBuilder';
import type {
    BankingAdoption,
    BankingAdoptionUpdateDto,
} from '../types/BankingAdoption';

export const useUpdateBankingAdoption = requestBuilder.mutation<
    BankingAdoption,
    BankingAdoptionUpdateDto
>({
    endpoint: `/api/banking-adoption`,
    method: 'PATCH',
});
